// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"c160c34e","583":"5b8a27a4","983":"42fdc826"}[chunkId] + ".chunk.js";
};